import { Link } from "@/i18n/Link";
import { ChevronRight } from "lucide-react";
import { useCopy } from "@/i18n/LocaleContext";

const COPY = {
  en: {
    ariaLabel: "Breadcrumb"
  },
  es: {
    ariaLabel: "Migas de pan"
  }
};

export interface Crumb {
  name: string;
  path: string;
}

export function Breadcrumbs({ trail }: { trail: Crumb[] }) {
  const t = useCopy(COPY);
  return (
    <nav aria-label={t.ariaLabel} className="text-sm text-muted-foreground">
      <ol className="flex flex-wrap items-center gap-1.5">
        {trail.map((c, i) => {
          const isLast = i === trail.length - 1;
          return (
            <li key={c.path} className="flex items-center gap-1.5">
              {isLast ? (
                <span aria-current="page" className="text-foreground font-medium">{c.name}</span>
              ) : (
                <Link to={c.path} className="hover:text-primary transition-colors">{c.name}</Link>
              )}
              {!isLast && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
